import { SCOPES_TITLE, TIER_SCOPES } from '../TierConsts';

const OutScopeBadge = () => {
    return (
        <div
            className={`h-6 px-2 items-center content-center rounded w-fit text-sm font-medium flex gap-2 bg-sf-negative-100`}>
            <div className={'text-sf-negative-600'}>{SCOPES_TITLE[TIER_SCOPES.OUT_SCOPE]}</div>
        </div>
    );
};

export default OutScopeBadge;
